//ModalTransition.jsx
import { useState, useEffect } from 'react';

export default function ModalTransition({ isOpen, onClose, children, className = "" }) {
  const [isAnimating, setIsAnimating] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      // Pequeño retraso para que se aplique la animación de entrada
      setTimeout(() => {
        setIsAnimating(true);
      }, 10);
    } else {
      setIsAnimating(false);
      // Esperar a que termine la animación de salida antes de dejar de renderizar
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300); // Este tiempo debe coincidir con la duración de la transición
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!shouldRender) return null;

  return (
    <div 
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-60 transition-opacity duration-300 ${
        isAnimating ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div 
        className={`transition-all duration-300 transform ${
          isAnimating ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        } ${className}`}
      >
        {children}
      </div>
    </div>
  );
}